// ============================================================
// useDraftSave.js — 입력 폼 자동저장(임시저장) 훅 (C)
// ============================================================
// 역할: 사용자가 입력 중인 내용을 localStorage에 자동으로 저장합니다.
//       브라우저를 실수로 닫아도 다시 열면 내용이 복원됩니다.
//
// 비유: 카카오톡에서 메시지 작성 중 앱을 껐다 켜도 내용이 남아있는 기능
// ============================================================

import { useCallback } from "react";

// localStorage 키 접두사 (시나리오마다 별도 저장)
const DRAFT_PREFIX = "report_draft_";

// 임시저장 데이터 구조:
// { formData: {...}, savedAt: "ISO날짜문자열" }

// ── 메인 훅 ──
export function useDraftSave() {

  // 임시저장 — formData가 변경될 때마다 호출
  const saveDraft = useCallback((scenarioKey, formData) => {
    if (!scenarioKey) return;
    try {
      const key = DRAFT_PREFIX + scenarioKey;
      const draft = {
        formData,
        savedAt: new Date().toISOString(),
      };
      localStorage.setItem(key, JSON.stringify(draft));
    } catch {
      // 저장 실패 시 조용히 무시
    }
  }, []);

  // 임시저장본 불러오기 — 시나리오 선택 시 호출
  // 반환값: { formData, savedAt } 또는 null (없으면)
  const loadDraft = useCallback((scenarioKey) => {
    if (!scenarioKey) return null;
    try {
      const key = DRAFT_PREFIX + scenarioKey;
      const raw = localStorage.getItem(key);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }, []);

  // 임시저장 삭제 — 보고서 생성 완료 후 호출
  const clearDraft = useCallback((scenarioKey) => {
    if (!scenarioKey) return;
    try {
      localStorage.removeItem(DRAFT_PREFIX + scenarioKey);
    } catch {
      // 무시
    }
  }, []);

  // 임시저장본이 존재하는지 확인 (복원 알림 토스트 표시 여부 결정용)
  const hasDraft = useCallback((scenarioKey) => {
    if (!scenarioKey) return false;
    return !!localStorage.getItem(DRAFT_PREFIX + scenarioKey);
  }, []);

  return { saveDraft, loadDraft, clearDraft, hasDraft };
}
